import React, { useState } from "react";
import { isMicroDepositRequestType } from "utils";
import TrustlyIntegration, {
  TrustlyIntegrationProps,
} from "./TrustlyIntegration";
import TrustlyMicroDepositInstruction from "./TrustlyMicroDepositInstruction";

export const scriptId = "trustlyIFrame";

const TrustlyIntegrationMain = (props: TrustlyIntegrationProps) => {
  const { requestType, onSuccess } = props;
  const microDepositRequestType = isMicroDepositRequestType(requestType);
  const [
    showMicroDepositVerifyInstruction,
    setShowMicroDepositVerifyInstruction,
  ] = useState(microDepositRequestType);

  if (showMicroDepositVerifyInstruction) {
    return (
      <TrustlyMicroDepositInstruction
        onExit={() => onSuccess([])}
        onContinue={() => setShowMicroDepositVerifyInstruction(false)}
      />
    );
  }
  return <TrustlyIntegration {...props} />;
};

export default TrustlyIntegrationMain;
